export const Q4_LAUNCH_CAMPAIGN = {
  id: 'q4_launch_2026',
} as const;

export const Q4_LAUNCH_LAST_SHOWN_DATE_KEY = 'Q4_LAUNCH_LAST_SHOWN_DATE';

export const shouldShowQ4LaunchDialog = (lastShownDate: string | undefined, today: string) => lastShownDate !== today;
